angular.module("bot")



  .factory("Bot", ($interval, $log, $q, $rootScope, $timeout, API, BOT_EVENTS, ChatSession, EVENTS) => {

    const SERVER_REFRESH_INTERVAL = 7000;
    const HUMANISE_DELAY = 4000;
    const HUMANISE_DELAY_MENU = 1000;
    const COMMENT_TYPE_NULL = "ctype_null";
    const status = {
      busy: true,
      awake: false,
      waitingForInput: false,
    }
    let startSessionCalled = false;

    let session;
    let sessionCache = "";
    let serverRefreshIntervalPromise = null;
    let isAlwaysAwakeMode = false;

    const init = alwaysAwakeMode => {
      isAlwaysAwakeMode = !!alwaysAwakeMode;
      if (isAlwaysAwakeMode) {
        status.awake = true;
      }
      $rootScope.$on(EVENTS.botPanelState, (e, params) => {
        status.awake = isAlwaysAwakeMode || session.panelOpen;
        _updateStatus();
      });
      $rootScope.$on(BOT_EVENTS.chatSessionReady, () => {
        if (_checkForSessionChanges()) {
          _updateStatus();
        }
      });
      $rootScope.$on(BOT_EVENTS.chatSessionRefreshed, () => {
        if (_checkForSessionChanges()) {
          _updateStatus();
        }
      });
    }


    const reset = () => {
      status.busy = true;
      status.awake = false;
      status.waitingForInput = false;
      startSessionCalled = false;
    }


    const _checkForSessionChanges = () => {
      session = ChatSession.session;
      if (JSON.stringify(session) === sessionCache) {
        return false;
      }
      sessionCache = JSON.stringify(session);
      status.awake = isAlwaysAwakeMode || (session && session.panelOpen);
      return true;
    }


    const _updateStatus = () => {

      // check for error state
      if (!session.conversation_key && session.transcript.length) {
        ChatSession.setErrorMessage("Existing chat session is missing a conversation_key. Click 'Reset chat session' to start a new session.");
        status.busy = true;
        return $log.warn("Bot error: found chat transcript without conversation_key. Stopping");
      }

      if (status.awake) {
        if (!session.conversation_key && !startSessionCalled) {
          startSessionCalled = true;
          _startNewSession();
        }
        if (!serverRefreshIntervalPromise) {
          serverRefreshIntervalPromise = $interval(() => {
            ChatSession.refreshFromServer();
          }, SERVER_REFRESH_INTERVAL); // server refresh checks for messages pushed from the server that won't be in the session
        }
        status.busy = false;

      } else {
        if (serverRefreshIntervalPromise) {
          $interval.cancel(serverRefreshIntervalPromise);
          serverRefreshIntervalPromise = null;
        }

      }
    }


    // should only run once per chat session
    const _startNewSession = () => {

      const unknownErrorMessage = "An unknown error occurred trying to start chat session";
      API.get("/2/bot/chat/start-session")
        .then(response => {
          if (!response.success || !response.transcript || !response.transcript.length) {
            session.errorMessage = unknownErrorMessage;
            return;
          }

          ChatSession.setKey(response.conversation_key);

          // a new session always contains a transcript of length 1 unless restoring an existing session from login when can contain more
          response.transcript.forEach(comment => {
            ChatSession.addComment(comment);
          });

          ChatSession.setMenu(response.menu, response.menuOnlyMode);
          status.waitingForInput = true;

        }, response => {
          session.errorMessage = response || unknownErrorMessage;
        })
        .finally(() => {
          status.busy = false;
        });
    }

    /**
     * 
     * @param {string} input 
     * @param {object} botContext 
     * @param {string | null} menuKey 
     * @returns {promise}
     */
    const ask = (input, botContext, menuKey = null) => {

      let deferred = $q.defer();
      const unknownErrorMessage = "An unknown error occurred trying to store your message";

      if (!session.conversation_key) {
        session.errorMessage = "No conversation key, cannot continue";
        return $q.reject();
      }
      const metadata = {
        context: botContext
      }
      if(menuKey){
        metadata.menuKey = menuKey;
      }
      // add any session script to the response. this is essential to pass the response back to the script on the server
      // NOTE when we accept external button clicks that inject bot questions
      // these will need to clear the script as they change to a fresh context
      if(session.script){
        metadata.script = session.script;
      }
      API.post("/2/bot/chat/" + session.conversation_key + "/user-comments", {
        content: input.trim(),
        metadata: metadata
      })
        .then(response => {
          if (!response.success) {
            session.errorMessage = unknownErrorMessage;
            return $q.reject();
          }

          if(!response.comment.id){
            $log.error("Comment has no ID, cannot continue");
            return $q.reject("Comment has no ID, cannot continue");
          }

          // add users's response to the session and process
          ChatSession.addComment(response.comment);
          ChatSession.setAnalyse(true);
          _respondToUserInput(response.comment, menuKey);
          deferred.resolve();

        }, response => {
          session.errorMessage = response && response.message ? response.message : unknownErrorMessage;
          deferred.reject();
        });

      return deferred.promise;
    }




    const _respondToUserInput = (userComment, menuKey) => {

      let deferred = $q.defer();
      let workingTimeout = menuKey ? HUMANISE_DELAY_MENU: HUMANISE_DELAY;
      const unknownErrorMessage = "An unknown error occurred trying to process your message";
      status.waitingForInput = false;

      // @NOTE we should arguably do this as part of when the user posts the question, then fake a delay before posting the bot's response
      // however separating them is simpler for initial development
      $timeout(() => {
        API.post("/2/bot/chat/" + session.conversation_key + "/analyse", {
          comment: userComment
        })
          .then(response => {
            if (!response.success) {
              session.errorMessage = unknownErrorMessage;
              return $q.reject();
            }

            // add bot's response to the session
            if (response.comment) {
              if (response.comment.type !== COMMENT_TYPE_NULL) {
                if (!response.comment.id) {
                  $log.error("Comment has no ID, cannot continue");
                  return $q.reject("Comment has no ID, cannot continue");
                }
                ChatSession.addComment(response.comment);
              }
            }
            if(response.menu){
              ChatSession.setMenu(response.menu, response.menuOnlyMode || false, true);
            } else {
              ChatSession.clearMenu();
            }
            if(response.script){
              ChatSession.setScript(response.script);
            } else {
              ChatSession.clearScript();
            }
            deferred.resolve();

          }, response => {
            session.errorMessage = response && response.message ? response.message : unknownErrorMessage;
            deferred.reject();
          })
          .finally(() => {
            ChatSession.setAnalyse(false);
          });

      }, workingTimeout);

    }



    return {
      ask: ask,
      getStatus: () => status,
      init: init,
      reset: reset
    };

  })
